const domains = [
  'gmail.com',
  'yahoo.com',
  'hotmail.com',
  'aol.com',
  'icloud.com',
  'outlook.com',
  'comcast.net',
  'msn.com',
  'live.com',
  'att.net',
  'ymail.com',
  'sbcglobal.net',
  'me.com',
  'verizon.net',
  'bellsouth.net',
  'mail.com',
  'rocketmail.com',
  'cox.net',
  'charter.net',
  'protonmail.com',
  'optonline.net',
  'aim.com',
  'mac.com',
  'yahoo.es',
  'earthlink.net',
  'windstream.net',
  'roadrunner.com',
  'twc.com',
  'juno.com',
  'frontier.com',
  'netzero.net',
  'netzero.com',
  'gmx.com',
  'centurylink.net',
  'ptd.net',
  'usa.com',
]

// Calculate the Levenshtein distance between two strings
const stringDistance = (string1: string, string2: string) => {
  if (!string1.length) return string2.length
  if (!string2.length) return string1.length

  let prevRow = Array.from({ length: string1.length + 1 }, (_, i) => i)
  let currRow = Array.from({ length: string1.length + 1 }, () => 0)
  // eslint forbids the use of ++ operator
  for (let i = 1; i <= string2.length; i += 1) {
    currRow[0] = i
    // eslint forbids the use of ++ operator
    for (let j = 1; j <= string1.length; j += 1) {
      const substitutionCost = string1[j - 1] === string2[i - 1] ? 0 : 1
      currRow[j] = Math.min(
        currRow[j - 1] + 1, // insertion
        prevRow[j] + 1, // deletion
        prevRow[j - 1] + substitutionCost // substitution
      )
    }
    ;[prevRow, currRow] = [currRow, prevRow] // swap rows for next iteration
  }

  return prevRow[string1.length]
}

const calculateDomainSuggestion = (inputDomain: string) => {
  // eslint forbids the use of ++ operator
  for (let i = 0; i < domains.length; i += 1) {
    const distance = stringDistance(inputDomain.toLowerCase(), domains[i])
    if (distance === 0) {
      return ''
    }
    if (distance <= 2) {
      return domains[i]
    }
  }
  return ''
}

export default calculateDomainSuggestion
